import axios from '../axios'

/**
 * 系统登录模块
 * 登录后 HttpOnly Cookie 由后端自动写入，前端不存 token
 */

// 登录（使用 SysLoginController，保留图形验证码 + License 检查）
export const login = data => {
    return axios({
        url: '/login',
        method: 'post',
        data,
        withCredentials: true
    })
}

// 登出
export const logout = () => {
    return axios({
        url: '/logout',
        method: 'post',
        withCredentials: true
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/login.js